import { useNotificationStore } from '@/store/notification.store';

import FaIcon from '../common/FaIcon';
interface NotificationBellProps {
  className?: string;
}

export function NotificationBell({ className = '' }: NotificationBellProps) {
  const { unreadCount, togglePanel, error } = useNotificationStore();

  return (
    <button
      type="button"
      onClick={togglePanel}
      aria-label={
        error
          ? 'Notifications (feed unavailable)'
          : `Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`
      }
      title={error ? 'Notifications unavailable - open to retry' : 'Notifications'}
      data-notification-bell
      className={`relative ${className}`}
    >
      <FaIcon icon="bell" className="h-5 w-5" />

      {/*
        When the feed failed to load, unreadCount is 0 — not stale-but-real — so a
        plain bell would tell the operator "nothing waiting" during an outage.
        Show a warning marker instead of the (meaningless) count.
      */}
      {error ? (
        <span
          aria-hidden="true"
          className="absolute -top-1 -right-1 flex h-3 w-3 items-center justify-center rounded-full bg-amber-500 ring-2 ring-white dark:ring-[#1a2538] pointer-events-none"
        />
      ) : unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-medium text-white pointer-events-none">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
